import { GetJobsStatusResponse } from 'api/reports-service/reports-service.types';

export const jobsStatus: GetJobsStatusResponse = {
  data: [
    {
      jobName: 'LOYALTY_PULSE',
      dataAvailableDate: '2022-10-16',
      updatedDate: '2022-10-16T22:54:27.908183091+01:00',
    },
    {
      jobName: 'GIFT_CARD_POOL',
      dataAvailableDate: '2026-06-02',
      updatedDate: '2026-06-02T22:54:27.908208551+01:00',
    },
    {
      jobName: 'EMAIL_INSIGHTS',
      dataAvailableDate: '2026-06-02',
      updatedDate: '2026-06-02T22:54:27.908214357+01:00',
    },
    {
      jobName: 'GUEST_JOURNEY',
      dataAvailableDate: '2026-06-02',
      updatedDate: '2026-06-02T22:54:27.908220114+01:00',
      ready: true,
      requiredTransactions: 1000,
      settingsProcessing: false,
    },
  ],
};
